import { replaceWithRegion } from 'actions/NavigationActions'
import { OptimizelyExperiments } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

interface DestinationMapping {
  destinationId: string
  destinationName: string
  matchingTerms: Array<string>
}

const destinationMappings: Record<string, DestinationMapping> = {
  seminyak: {
    destinationId: 'le_790d9f1f52e10ef90ede8efcf7f3c078',
    destinationName: 'Seminyak',
    matchingTerms: ['seminyak'],
  },
  nusaDua: {
    destinationId: 'le_a55472983efa2e239b315de91576d1d3',
    destinationName: 'Nusa Dua',
    matchingTerms: ['nusa dua', 'nusadua'],
  },
  newYork: {
    destinationId: 'le_1ada7faf229425b786d87f7d9d5d43f2',
    destinationName: 'New York',
    matchingTerms: ['new york', 'newyork', ' nyc ', ' ny '],
  },
  losAngeles: {
    destinationId: 'le_079230e29195cac1ce62e737740797a0',
    destinationName: 'Los Angeles',
    // not matching on 'la' as it's too common
    matchingTerms: ['los angeles', 'losangeles', ' la '],
  },
}

const useSpecificPaidLandingPageExperiment = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const utmTerm = searchParams.get('utm_term')
  const hasUtmTerm = !!utmTerm
  const isExperimentEnabled = useOptimizelyExperiment(OptimizelyExperiments.specificPaidLandingPage, hasUtmTerm)

  useEffect(() => {
    if (!isExperimentEnabled || !utmTerm) {
      return
    }

    const normalizedUtmTerm = utmTerm.replace(/[^a-zA-Z0-9]/g, ' ').toLowerCase()
    const matchingDestination = Object.values(destinationMappings).find(mapping =>
      mapping.matchingTerms.some(term => {
        if (!term) {
          return false
        }
        return normalizedUtmTerm.toLowerCase().includes(term.toLowerCase())
      }),
    )

    if (matchingDestination) {
      const { destinationId, destinationName } = matchingDestination
      const newSearchParams = new URLSearchParams(searchParams)

      newSearchParams.set('destinationName', destinationName)
      newSearchParams.set('destinationId', destinationId)
      const paramsToDelete = ['utm_term',
        'utm_campaign',
        'utm_source',
        'utm_medium',
        'utm_content',
        'utm_id',
        'utm_creative_format',
        'utm_adgroup',
        'gad_source',
        'utm_bp',
      ]
      paramsToDelete.forEach(param => newSearchParams.delete(param))

      const path = '/search'
      const queryString = newSearchParams.toString()
      const destinationPath = queryString ? `${path}?${queryString}` : path
      dispatch(replaceWithRegion(destinationPath))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useSpecificPaidLandingPageExperiment
